module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p13-B-a40d1fbc25082ce3553194ffdfad9f00.png";